import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import { formatAmountObject } from "@/partner/features/products";
import { interpolationFormat } from "@/partner/shared/lib";
import { RefundStatusChip } from "@/partner/entities/refunds";
import type { PaymentRefund } from "../model/paymentBreakdown";

/**
 * Возвраты по платежу: дата, сумма, статус. Общая таблица для диалога
 * покупки и диалога платежа.
 */
export const PaymentRefundsTable: FC<{ refunds: readonly PaymentRefund[] }> = ({
  refunds,
}) => {
  const { t, i18n } = useTranslation();
  const emptyValue = t("common.emptyDash");

  return (
    <Table size="small">
      <TableBody>
        {refunds.map((refund) => (
          <TableRow key={refund.id}>
            <TableCell sx={{ border: 0, pl: 0 }}>
              {interpolationFormat(refund.createdAt, "dateTime", i18n.language)}
            </TableCell>
            <TableCell align="right" sx={{ border: 0, whiteSpace: "nowrap" }}>
              {formatAmountObject(refund.amount, emptyValue)}
            </TableCell>
            <TableCell align="right" sx={{ border: 0, pr: 0 }}>
              <RefundStatusChip refund={refund} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
